import { logAppError } from 'Helpers/logger'
import { getDeliverabilityIndexSenderFlag } from './actions'
import { deliverabilityIndexState } from './state'

export const deliverabilityIndexCallback = ({ set }) => async () => {
  set(deliverabilityIndexState, prev => ({
    ...prev,
    loaded: false,
    loading: true
  }))

  try {
    const senderFlag = await getDeliverabilityIndexSenderFlag()

    set(deliverabilityIndexState, prev => ({
      ...prev,
      ...senderFlag
    }))
  } catch (error) {
    logAppError({
      Component: 'BannerMailupShield',
      Method: 'deliverabilityIndexCallback',
      appError: error
    })
  }
  set(deliverabilityIndexState, prev => ({
    ...prev,
    loaded: true,
    loading: false
  }))
}
